import React from 'react';

export default function ContainerLayout({ children }) {
  return <div className="containerLayout">{children}</div>;
}
